module.exports = __webpack_public_path__ + "img/respondi-logo-gray.d2929487.png";